/* 🤖 this file was generated by svg-to-ts */
export const matIconArrowDropDown: {
  name: 'arrow-drop-down';
  data: string;
} = {
  name: 'arrow-drop-down',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m7 10 5 5 5-5H7z"/></svg>`
};
